export default class User {
  /**
   * @type {number}
  */
  id;

  /**
   * @type {number}
  */
  departmentId;

  /**
   * @type {string}
  */
  fullName;

  /**
   * @type {string}
  */
  email;

  /**
   * @type {string}
  */
  username;

  /**
   * @type {string}
  */
  password;

  /**
   * @type {string}
  */
  salt;

  /**
   * @type {string}
  */
  phone;

  /**
   * @type {boolean}
  */
  active;

  /**
   * @type {string}
  */
  dateAdded;

  /**
   * @type {string}
  */
  token;

  /**
   * @type {array}
  */
  allowedOffices = [];

  /**
   * @type {number}
  */
  physicalOfficeLocation;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.id != null) {
        this.id = opts.id;
      }
      if (opts.departmentId != null) {
        this.departmentId = opts.departmentId;
      }
      if (opts.fullName != null) {
        this.fullName = opts.fullName;
      }
      if (opts.email != null) {
        this.email = opts.email;
      }
      if (opts.username != null) {
        this.username = opts.username;
      }
      if (opts.password != null) {
        this.password = opts.password;
      }
      if (opts.salt != null) {
        this.salt = opts.salt;
      }
      if (opts.phone != null) {
        this.phone = opts.phone;
      }
      if (opts.active != null) {
        this.active = opts.active;
      }
      if (opts.dateAdded != null) {
        this.dateAdded = opts.dateAdded;
      }
      if (opts.token != null) {
        this.token = opts.token;
      }
      if (opts.allowedOffices != null) {
        this.allowedOffices = opts.allowedOffices;
      }
      if (opts.physicalOfficeLocation != null) {
        this.physicalOfficeLocation = opts.physicalOfficeLocation;
      }
    }
  }
}
